'use es6';

import { getIsMarketingContactsSku } from 'pricing-pages-lib/utils/productsUtils';
import { createSelector } from 'reselect';
import { marketingContactsOnRenewalSelector } from 'pricing-pages-unified-ui/selectors/MarketingContactsSelectors';
import { getMinimumNumberOfPurchasableContacts, getContactsQuantityMultiplier, getPurchasedMarketingContactsQuantity, getPurchasedNonMarketingContactsQuantity, getPurchasedContactsQuantity } from 'pricing-pages-lib/utils/contactsUtils';
import { createSelectorFromUtil } from 'pricing-pages-lib/utils/selectorUtils';
import { contactTierPriceMapSelector } from './PricingSelectors';
import { skuSelector } from './ProductsSelectors';
import { transformState } from './SelectorUtils';
import { getAdditionalUnitsInProductLineFromProductInventory } from 'pricing-pages-lib/utils/productInventoryUtils';
import { MARKETING } from 'self-service-api/constants/ProductLines';
export const numContactsInCrmSelector = state => {
  return state.numContactsInCrm;
}; // Returns the contacts quantity multiplier for the additionalUnitMerchId of the activeMerchId

export const contactsQuantityMultiplierSelector = createSelectorFromUtil(getContactsQuantityMultiplier, transformState);
export const purchasedMarketingContactsQuantitySelector = createSelectorFromUtil(getPurchasedMarketingContactsQuantity, transformState);
export const purchasedNonMarketingContactsQuantitySelector = createSelectorFromUtil(getPurchasedNonMarketingContactsQuantity, transformState);

const includedAdditionalUnitsSelector = (state, {
  quantityPackSkuId
}) => {
  return skuSelector(state, {
    skuId: quantityPackSkuId
  }).quantityUnit.includedWithProductVersion;
}; // returns minimum amount of contacts a user can buy


export const minPurchasableContactsSelector = createSelector([includedAdditionalUnitsSelector, numContactsInCrmSelector, marketingContactsOnRenewalSelector, contactsQuantityMultiplierSelector, purchasedNonMarketingContactsQuantitySelector, (state, {
  quantityPackSkuId
}) => getIsMarketingContactsSku(transformState(state), {
  skuId: quantityPackSkuId
}), state => getAdditionalUnitsInProductLineFromProductInventory(transformState(state), {
  productLine: MARKETING
})], (includedAdditionalUnits, numContactsInCrm, marketingContactsOnRenewal, contactsQuantityMultiplier, purchasedContactsQuantity, isMarketingContactsSku, totalOwnedMarketingContactsInCurrentPlan) => {
  return getMinimumNumberOfPurchasableContacts({
    includedAdditionalUnits,
    numContactsInCrm,
    marketingContactsOnRenewal,
    contactsQuantityMultiplier,
    purchasedContactsQuantity,
    isMarketingContactsSku,
    totalOwnedMarketingContactsInCurrentPlan
  });
});
export const legacyIncludedAdditionalContactsSelector = (state, {
  quantityPackSkuId
}) => {
  const quantityPack = skuSelector(state, {
    skuId: quantityPackSkuId
  });
  const {
    quantityUnit: {
      includedWithQuantityPack
    }
  } = quantityPack;
  const priceTiers = contactTierPriceMapSelector(state, {
    quantityPackSkuId
  });

  if (priceTiers.length && priceTiers[0].value === 0) {
    return priceTiers[0].upperBound * includedWithQuantityPack;
  }

  return 0;
};
export const purchasedContactsQuantitySelector = createSelectorFromUtil(getPurchasedContactsQuantity, transformState);